var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "ds-custom-query" },
    [
      _c(
        "el-aside",
        { attrs: { width: "20%" } },
        [
          _c("el-tree", {
            attrs: {
              data: _vm.queryFieldData,
              props: _vm.defaultProps,
              "default-expand-all": "",
              "expand-on-click-node": false,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var node = ref.node
                    var data = ref.data
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "ds-field-tree-custom-node",
                          on: {
                            dblclick: function ($event) {
                              return _vm.pushQueryItem(node, data)
                            },
                          },
                        },
                        [
                          _c(
                            "DsfCustomQueryField",
                            {
                              attrs: {
                                node: node,
                                data: data,
                                "drag-proxy-append-to": ".ds-custom-query",
                              },
                              on: { drag: _vm.fieldDragHandler },
                            },
                            [_vm._t("field-node")],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "el-main",
        { ref: "main" },
        [
          _vm.isEmptyItems
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      height: "100%",
                      "align-items": "center",
                      "justify-content": "center",
                    },
                  },
                  [_vm._v("请双击或拖拽左侧相关字段到此处")]
                ),
              ]
            : _c("DsfCustomQueryLogic", {
                ref: "logic",
                attrs: {
                  data: _vm.queryLogicData,
                  "drag-proxy-append-to": ".ds-custom-query",
                },
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }